import { Alignment, Classes, Navbar } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { ROUTE } from 'src/constants/routes';
import { TEST_IDS } from 'src/constants/testIds';
import * as copy from 'src/templates/copy';
import logo from 'src/templates/images/navbar-logo.png';

export const AppNavbar: React.VFC = () => {
  return (
    <Navbar
      className={classNames('sd-app-navbar', Classes.DARK)}
      data-testid={TEST_IDS.appNavbar.container}
    >
      <Navbar.Group align={Alignment.LEFT}>
        <Link
          className={classNames('sd-app-navbar__logo', Classes.NAVBAR_HEADING)}
          to={ROUTE.HOME}
        >
          <img
            alt={`${copy.components.appNavbar.title} logo`}
            data-testid={TEST_IDS.appNavbar.logo}
            src={logo}
          />
        </Link>
      </Navbar.Group>
    </Navbar>
  );
};
